import { Accordion, AccordionItem, Collapse, Row } from 'reactstrap';

import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useMatch } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { formatUSD } from '../../../../../../helpers/helpers';
import { getUserHubsTradingInfo } from '../../../slice';
import { Tile } from '../../../../../../Components/Custom/Tile';
import { TradingHub } from '../TradingHub';

export const Trading = () => {
  const { trading } = useAppSelector((state) => state.userDetails);

  const [col, setCol] = useState(true);

  const t_col = () => {
    setCol(!col);
  };

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    if (trading !== null) return;
    dispatch(getUserHubsTradingInfo(Number(userId)));
  }, []);

  return (
    <div>
      {' '}
      <h5>My Trading HUB Membership summary</h5>
      <Row>
        <Tile label='TOTAL TRADING HUB NFT ORDERS'>
          {formatUSD(trading?.summary?.totalOrderAmount)}
          <span className='text-muted fs-14'> USDT</span>
        </Tile>
        <Tile label='MAX DEPOSIT'>
          {trading?.summary?.maxDeposit === 'UNLIMITED' ? (
            'UNLIMITED'
          ) : (
            <>
              {formatUSD(trading?.summary?.maxDeposit || 0)}{' '}
              <span className='text-muted fs-14'>USDT</span>
            </>
          )}
        </Tile>
        <Tile label='TRADING BINARY'>
          {trading?.summary?.tradingBinary}
          <span className='text-muted fs-14'> %</span>
        </Tile>
      </Row>
      <Accordion open={'4'}>
        <AccordionItem>
          <h2 className='accordion-header' id='headingTwo'>
            <button
              className={classnames('accordion-button', { collapsed: !col })}
              type='button'
              onClick={t_col}
              style={{ cursor: 'pointer' }}>
              Trading HUB NFTs
            </button>
          </h2>
          <Collapse isOpen={col} className='accordion-collapse'>
            <div className='accordion-body'>
              {trading?.userPackages?.map((data, i) => (
                <TradingHub key={i} data={data} />
              ))}
            </div>
          </Collapse>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
